{
  "familyId": "SPR-HOOFDLETTER",
  "questions": [
    {
      "id": "SPR-HOOFDLETTER-001",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "In welke zin is de hoofdletter correct gebruikt?",
      "context": null,
      "options": [
        "emma woont in Amsterdam.",
        "Emma woont in Amsterdam.",
        "Emma woont in amsterdam.",
        "emma woont in amsterdam."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Hoofdletterregels", "content": "Gebruik een hoofdletter bij: namen van personen (Emma, Jan), namen van plaatsen (Amsterdam, Nederland), begin van een zin.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_naam",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "In deze zin heb je twee namen: 'Emma' (persoonsnaam) en 'Amsterdam' (plaatsnaam). Beide moeten met een hoofdletter. Gewone woorden zoals 'woont' en 'in' krijgen geen hoofdletter.",
        "solutionSteps": [
          "Stap 1: Zoek de namen → 'Emma' (persoon) en 'Amsterdam' (plaats)",
          "Stap 2: Namen krijgen altijd een hoofdletter",
          "Stap 3: Controleer het begin van de zin → ook een hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Fout: 'emma' is een persoonsnaam en moet met een hoofdletter: Emma. De fout is dat de naam van een persoon met een kleine letter is geschreven.",
          "1": "Correct! 'Emma' (persoonsnaam) en 'Amsterdam' (plaatsnaam) hebben allebei terecht een hoofdletter.",
          "2": "Fout: 'amsterdam' is een plaatsnaam en moet met een hoofdletter: Amsterdam. De fout is dat de naam van een stad met een kleine letter is geschreven.",
          "3": "Fout: zowel 'emma' (persoonsnaam) als 'amsterdam' (plaatsnaam) moeten met een hoofdletter. Beide namen zijn hier foutief met een kleine letter geschreven."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-002",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct geschreven?",
      "context": null,
      "options": [
        "de hond rent door het park.",
        "De hond rent door het park.",
        "De Hond rent door het park.",
        "De hond Rent door het park."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Begin van een zin", "content": "Het eerste woord van een zin schrijf je altijd met een hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_zinsbegin",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het eerste woord van een zin schrijf je altijd met een hoofdletter. 'De' is het eerste woord, dus schrijf je 'De' met een hoofdletter D.",
        "solutionSteps": [
          "Stap 1: Het eerste woord van een zin krijgt een hoofdletter",
          "Stap 2: Controleer of er namen in de zin staan → nee",
          "Stap 3: Alleen 'De' (zinsbegin) krijgt een hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Fout: 'de' begint met een kleine letter, maar het eerste woord van een zin moet een hoofdletter hebben: 'De hond...' De fout is een ontbrekende hoofdletter aan het zinsbegin.",
          "1": "Correct! 'De' begint met een hoofdletter omdat het het eerste woord van de zin is.",
          "2": "Fout: 'Hond' is geen naam en staat niet aan het begin van de zin. De fout is dat een gewoon zelfstandig naamwoord onterecht een hoofdletter heeft gekregen.",
          "3": "Fout: 'Rent' is een gewoon werkwoord in het midden van de zin. De fout is dat een werkwoord onterecht een hoofdletter heeft gekregen — alleen namen en het eerste woord krijgen een hoofdletter."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-003",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke zin heeft alle hoofdletters op de juiste plek?",
      "context": null,
      "options": [
        "Vorige week ging ik naar amsterdam met mijn oma.",
        "Vorige week ging ik naar Amsterdam met mijn Oma.",
        "Vorige week ging ik naar Amsterdam met mijn oma.",
        "vorige week ging ik naar Amsterdam met mijn oma."
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Plaatsnamen", "content": "Namen van steden, landen en plaatsen schrijf je altijd met een hoofdletter: Amsterdam, Nederland, Europa. Gewone woorden zoals 'oma' krijgen geen hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_plaatsnaam",
      "variantIndex": 3,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vorige' krijgt een hoofdletter (begin van de zin) en 'Amsterdam' krijgt een hoofdletter (plaatsnaam). Het woord 'oma' is geen naam en krijgt dus geen hoofdletter.",
        "solutionSteps": [
          "Stap 1: Eerste woord 'Vorige' → hoofdletter (zinsbegin)",
          "Stap 2: 'Amsterdam' → hoofdletter (plaatsnaam)",
          "Stap 3: 'oma' → geen hoofdletter (gewoon woord, geen naam)"
        ],
        "distractorExplanations": {
          "0": "Fout: 'amsterdam' is een plaatsnaam en moet met een hoofdletter: Amsterdam. De fout is dat een stadsnaam met een kleine letter is geschreven.",
          "1": "Bijna goed, maar 'Oma' is geen eigennaam — het is een gewoon zelfstandig naamwoord. De fout is dat een familieaanduiding onterecht een hoofdletter heeft gekregen. Het moet 'oma' zijn.",
          "2": "Correct! 'Vorige' (zinsbegin) en 'Amsterdam' (plaatsnaam) hebben een hoofdletter. 'Oma' is een gewoon woord en krijgt geen hoofdletter.",
          "3": "Fout: 'vorige' is het eerste woord van de zin en moet met een hoofdletter beginnen. De fout is een ontbrekende hoofdletter aan het zinsbegin."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-004",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "In welke zin zijn alle hoofdletters correct gebruikt?",
      "context": null,
      "options": [
        "mijn vriend thomas woont in Rotterdam.",
        "Mijn vriend Thomas woont in Rotterdam.",
        "Mijn Vriend Thomas woont in Rotterdam.",
        "Mijn vriend thomas woont in rotterdam."
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Overzicht hoofdletterregels", "content": "Hoofdletter bij: 1) begin van een zin, 2) namen van personen, 3) namen van plaatsen. Gewone woorden zoals 'vriend' krijgen geen hoofdletter.", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_combinatie",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "In de correcte zin: 'Mijn' heeft een hoofdletter (begin van de zin), 'Thomas' heeft een hoofdletter (persoonsnaam), 'Rotterdam' heeft een hoofdletter (plaatsnaam). Het woord 'vriend' is een gewoon woord en krijgt geen hoofdletter.",
        "solutionSteps": [
          "Stap 1: 'Mijn' → hoofdletter (zinsbegin)",
          "Stap 2: 'Thomas' → hoofdletter (persoonsnaam)",
          "Stap 3: 'Rotterdam' → hoofdletter (plaatsnaam)",
          "Stap 4: 'vriend' → geen hoofdletter (gewoon woord)"
        ],
        "distractorExplanations": {
          "0": "Fout: 'mijn' begint de zin en moet een hoofdletter hebben. Ook 'thomas' is een persoonsnaam en moet 'Thomas' zijn. De fouten zijn: ontbrekende hoofdletter aan zinsbegin én bij een persoonsnaam.",
          "1": "Correct! 'Mijn' (zinsbegin), 'Thomas' (naam) en 'Rotterdam' (plaatsnaam) hebben alle drie terecht een hoofdletter.",
          "2": "Fout: 'Vriend' is een gewoon zelfstandig naamwoord, geen eigennaam. De fout is dat een gewoon woord onterecht een hoofdletter heeft gekregen — alleen namen krijgen een hoofdletter.",
          "3": "Fout: 'thomas' (persoonsnaam) moet 'Thomas' zijn, en 'rotterdam' (plaatsnaam) moet 'Rotterdam' zijn. Beide eigennamen zijn foutief met een kleine letter geschreven."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-005",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "multiple_choice",
      "question": "Welke woorden hoeven GEEN hoofdletter in deze zin?\n'Op maandag gaat Lisa naar school in Nederland.'",
      "context": null,
      "options": ["maandag en school", "Lisa en Nederland", "maandag en Nederland", "alleen Lisa"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "data": {"title": "Wanneer geen hoofdletter?", "content": "Gewone zelfstandige naamwoorden (school, huis) en dagen van de week (maandag, dinsdag) krijgen in het Nederlands GEEN hoofdletter. Wel een hoofdletter bij: namen van personen (Lisa) en landen (Nederland).", "icon": "book"}, "showWhen": "wrong"}],
      "conceptId": "hoofdletter_geen",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "In het Nederlands schrijf je dagen van de week (maandag, dinsdag) en gewone zelfstandige naamwoorden (school, huis) met een kleine letter. Persoonsnamen (Lisa) en landnamen (Nederland) krijgen wél een hoofdletter.",
        "solutionSteps": [
          "'maandag' = dag van de week → kleine letter",
          "'school' = gewoon zelfstandig naamwoord → kleine letter",
          "'Lisa' = persoonsnaam → hoofdletter",
          "'Nederland' = landnaam → hoofdletter"
        ],
        "distractorExplanations": {
          "0": "Goed! In het Nederlands schrijf je dagen (maandag) en gewone woorden (school) met een kleine letter. Alleen namen van personen en plaatsen krijgen een hoofdletter.",
          "1": "Lisa is een persoonsnaam en Nederland is een landnaam — die krijgen juist wél een hoofdletter. De woorden zonder hoofdletter zijn 'maandag' en 'school'.",
          "2": "Bijna goed: 'maandag' hoeft inderdaad geen hoofdletter (dag van de week), maar 'Nederland' is een landnaam en krijgt wél een hoofdletter. De twee woorden zonder hoofdletter zijn 'maandag' en 'school'.",
          "3": "Lisa krijgt juist wél een hoofdletter (persoonsnaam). De woorden zonder hoofdletter zijn 'maandag' (dag van de week) en 'school' (gewoon woord)."
        }
      }
    },
    {
      "id": "SPR-HOOFDLETTER-006",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "error_spotting",
      "question": "Zoek de hoofdletterfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Op woensdag gaat jan met zijn moeder naar utrecht. Ze gaan naar het Museum en daarna eten ze een ijsje.",
        "errors": [
          {
            "word": "jan",
            "position": 3,
            "correction": "Jan",
            "explanation": "'Jan' is een persoonsnaam en moet met een hoofdletter."
          },
          {
            "word": "utrecht",
            "position": 8,
            "correction": "Utrecht",
            "explanation": "'Utrecht' is een plaatsnaam en moet met een hoofdletter."
          },
          {
            "word": "Museum",
            "position": 12,
            "correction": "museum",
            "explanation": "'Museum' is een gewoon zelfstandig naamwoord en krijgt geen hoofdletter (tenzij het een eigennaam is)."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletterregels", "content": "Hoofdletter bij: namen van personen (Jan), namen van plaatsen (Utrecht), begin van een zin. Geen hoofdletter bij: gewone woorden (museum, school, park).", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_error_spotting",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Drie fouten: 'jan' moet 'Jan' zijn (persoonsnaam), 'utrecht' moet 'Utrecht' zijn (plaatsnaam), 'Museum' moet 'museum' zijn (gewoon woord, geen eigennaam). Correct: 'Op' (zinsbegin), 'Ze' (zinsbegin) ✓",
        "solutionSteps": [
          "Fout 1: jan → Jan (persoonsnaam → hoofdletter)",
          "Fout 2: utrecht → Utrecht (plaatsnaam → hoofdletter)",
          "Fout 3: Museum → museum (gewoon woord → kleine letter)",
          "Correct: 'Op' en 'Ze' (zinsbegin) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-HOOFDLETTER-007",
      "familyId": "SPR-HOOFDLETTER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "hoofdletter_gebruik",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: welke krijgen een hoofdletter en welke niet?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Hoofdletter", "Kleine letter"],
        "items": [
          { "text": "Amsterdam", "correctCategory": 0 },
          { "text": "school", "correctCategory": 1 },
          { "text": "Emma", "correctCategory": 0 },
          { "text": "maandag", "correctCategory": 1 },
          { "text": "Nederland", "correctCategory": 0 },
          { "text": "fiets", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hoofdletter of niet?", "content": "Hoofdletter: namen van personen (Emma), plaatsen (Amsterdam) en landen (Nederland).\nKleine letter: gewone woorden (school, fiets) en dagen van de week (maandag).", "icon": "book" } }
      ],
      "conceptId": "hoofdletter_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Hoofdletter: Amsterdam (plaatsnaam), Emma (persoonsnaam), Nederland (landnaam). Kleine letter: school (gewoon woord), maandag (dag van de week), fiets (gewoon woord). In het Nederlands krijgen alleen eigennamen een hoofdletter.",
        "solutionSteps": [
          "Amsterdam → plaatsnaam → hoofdletter",
          "School → gewoon woord → kleine letter",
          "Emma → persoonsnaam → hoofdletter",
          "Maandag → dag van de week → kleine letter",
          "Nederland → landnaam → hoofdletter",
          "Fiets → gewoon woord → kleine letter"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    }
  ]
}